export type DcsObject = {
  isForceUpdate: boolean;
  dcsObjectType: string;
  dcsID: string;
  dcsObjectPath: string;
  matchedValue: string;
};

/**
 * Identifies DCS variables inside template string, and returns an array of DCS objects identified in string
 * @param str string containing DCS variables, for example: "The price is {{bundles.FOO.bar.baz}}"
 * @returns DCS objects identified in the string, and parsed text replacing occurrences of DCS variables with incrementing integers
 * @example
 * const { dcsObjects, parsedText } = parseDCSTemplateText("lorem {{bundles.FOO.bar.baz}}, ipsum {{!products.FOO.bar}}");
 * // dcsObjects: [
 * //   { dcsObjectType: "bundles", dcsID: "FOO", dcsObjectPath: "bar.baz", isForceUpdate: false, matchedValue: {{bundles.FOO.bar.baz}} },
 * //   { dcsObjectType: "products", dcsID: "FOO", dcsObjectPath: "bar", isForceUpdate: true, matchedValue: {{!products.FOO.bar} }
 * // ]
 */
export function parseDCSTemplateText(str: string): DcsObject[] | undefined {
  const dcsMatchRegExp = /\{\{\s*(\!)?\s*(bundles|products)\.(?:(\w+)\.)((?:\w+\.?)+)?\}\}/gim;
  const dcsMatches = str.match(dcsMatchRegExp);

  return dcsMatches?.reduce((arr, expression) => {
    const expressionMatchRegExp = /\s*(\!)?\s*(bundles|products)\.(?:(\w+)\.)((?:\w+\.?)+)?/gim;
    const expressionMatch = expressionMatchRegExp.exec(expression);
    if (!expressionMatch) return arr;
    const [, isForceUpdate, dcsObjectType, dcsID, dcsObjectPath] = expressionMatch;
    if (!dcsObjectType || !dcsID || !dcsObjectPath) return arr;
    arr.push({ isForceUpdate: Boolean(isForceUpdate), dcsObjectType, dcsID, dcsObjectPath, matchedValue: expression });
    return arr;
  }, [] as DcsObject[]);
}
